import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { useRef } from 'react'
import { DEFAULT_ORDER } from './Footer1.const'
import useStyles from './Footer1.styled'

export const useFooter1 = props => {
	const { metaData } = props
	const classes = useStyles(props)
	const sortHandlerParentRef = useRef()

	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.copyRights })
	const { handleFocus: handleImageClick } = useFieldFocus({ metaData: metaData.path })

	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.copyRights,
		key: 'copyRights',
	})

	return [
		{
			classes,
			defaultOrder: DEFAULT_ORDER,
			text: metaData.copyRights?.metaValue,
			textConfig: metaData.copyRights?.config,
			textEditable,
			alignment: metaData.alignment?.metaValue,
			direction: metaData.alignment?.contentDirection(),
			image: metaData.path,
			withImage: !!metaData.path?.image,
			isCentered: metaData.alignment?.isCenterAlignment,
			textAlignment: metaData.alignment?.textAlignment,
			textKey: metaData.copyRights?.tierKey,
			sortHandlerParentRef,
		},
		{ handleImageClick, handleTextClick, handleTextChange },
	]
}
